/**
 * FlowDraftActionsBar
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { Save, RotateCcw } from 'lucide-react';

import { Button } from '@/components/ui';
import { cn } from '@/lib/utils';

interface FlowDraftActionsBarProps {
  dirtyCount: number;
  saving: boolean;
  onReset: () => void;
  onSave: () => void;
  className?: string;
}

export const FlowDraftActionsBar: FC<FlowDraftActionsBarProps> = ({
  dirtyCount,
  saving,
  onReset,
  onSave,
  className,
}) => {
  const isDirty = dirtyCount > 0;

  return (
    <div
      className={cn(
        'flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between',
        'rounded-lg border bg-card px-4 py-3',
        className,
      )}
    >
      <div className="text-sm">
        <span className={cn('font-medium', isDirty ? 'text-warning' : 'text-muted-foreground')}>
          {isDirty ? 'Unsaved changes' : 'No changes'}
        </span>
        <span className="text-muted-foreground"> · </span>
        <span className="text-muted-foreground">
          {dirtyCount} item(s) modified
        </span>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={onReset}
          disabled={!isDirty || saving}
        >
          <RotateCcw className="mr-2 h-4 w-4" />
          Reset
        </Button>
        <Button
          variant="success"
          size="sm"
          onClick={onSave}
          disabled={!isDirty || saving}
          loading={saving}
        >
          <Save className="mr-2 h-4 w-4" />
          Save
        </Button>
      </div>
    </div>
  );
};

export default FlowDraftActionsBar;

